module.exports = __webpack_public_path__ + "img/box.45c63a92.png";